import styled from "styled-components";
import Color from "../../constants/Color";

const Button = styled.a`
    
    width: 300px;
    height: 50px;

    border: 1px solid ${Color.Gold};
    border-radius: 10px;

    color: ${Color.Gold};
    background-color: ${Color.Black}aa;
    
    font-weight: 700;
    font-size: 20px;
    text-align: center;
    line-height: 50px;
    letter-spacing: 0.05em;

    text-decoration: none;

    cursor: pointer;

    &:hover {
        background-color: ${Color.Gold};
        color: ${Color.Black};
        box-shadow: 0 0 10px ${Color.Gold}80;
    }
`

export default Button